import { useStore } from "@/stores/useStore";
import { useShopConfig } from "@/hooks/shop/useShopConfig";
import { useMemo } from "react";
import { Employee, EmployeeJobTitle } from "@/types/v2";

export const useServiceAdvisors = () => {
  const employees = useStore((s) => s.employees);
  const shopConfig = useShopConfig();

  return useMemo<Employee[]>(() => {
    if (shopConfig.useShopHeroEmployeeJobTitle) {
      return (
        employees?.filter(
          (e) => e.shopHeroJobTitle === EmployeeJobTitle.serviceAdvisor
        ) || []
      );
    }
    return employees || [];
  }, [shopConfig, employees]);
};
